import PetAvatar from '../PetAvatar.jsx'

function SvgPetRenderer(props) {
  return <PetAvatar {...props} />
}

export default SvgPetRenderer
